import Vue from "vue"

Vue.directive('client-only', {
    inserted(el, binding, vnode) {
        if (typeof window === 'undefined') {
            el.parentNode.removeChild(el)
        }
    }
})



// WEBPACK FOOTER //
// ./src/directives/index.js